import { LocaleEmail } from '../../Types.js'

const values: LocaleEmail = {
  free: ['gmail.com', 'yahoo.com', 'hotmail.com'],
  example: ['example.org', 'example.com', 'example.net'],
}

export default values
